<template>
  <ca-modal
    ref="modal"
    title="Como funciona o cálculo de férias coletivas"
    size="small">
    <ca-row slot="body">
      <ca-col size="12">
        <p>
          Calcule as férias coletivas dos funcionários em grupo, antes, verifique as
          condições/regras de acordo com cada situação:
        </p>
        <ca-list theme="check">
          <ca-list-item>
            Funcionário com férias proporcionais <strong>maior</strong> que os dias de férias
            coletivas: o recibo de férias será calculado, se houver saldo de
            férias ficará em aberto (para quitação em momento oportuno), e
            iniciará um novo período aquisitivo a partir do dia seguinte ao
            início das férias coletivas;
          </ca-list-item>

          <ca-list-item>
            Funcionário com férias vencidas <strong>maior</strong> que os dias de férias
            coletivas: o recibo de férias será calculado e <strong>não</strong> será alterado
            o período aquisitivo;(calcula férias normal;
          </ca-list-item>

          <ca-list-item>
            Funcionário com férias proporcionais <strong>menor</strong> que os dias de férias
            coletivas: o recibo de férias não é calculado, será necessário calcular como
            férias individual, o período aquisitivo ficará negativo (em aberto) até que o
            período esteja completo.
          </ca-list-item>

          <ca-list-item>
            Funcionário com férias vencidas <strong>menor</strong> que os dias de férias
            coletivas: o recibo de férias não é calculado, será necessário calcular como
            férias individual.
          </ca-list-item>
        </ca-list>
      </ca-col>
    </ca-row>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="$refs.modal.close()">
          Fechar
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
export default {
  name: 'VacationRolesModal',
};
</script>
